<template>

    <insurance-table :site-id="rowData.id" :cient-site-id="rowData.siteId" :read-only="readOnly" :site-name="rowData.siteName" />

</template>


<script>

import SiteMixins from '@/mixins/SiteMixins'

import InsuranceTable from '@/components/tables/InsuranceTable'

export default {
  components: {
    InsuranceTable
  },

  mixins: [SiteMixins],

  props: {
    rowData: {
      type: Object,
      required: true
    },
    showRenewal: {
      type: Boolean,
      default: true
    },
    editable: {
      type: Boolean,
      default: false
    },

    readOnly: {
      type: Boolean,
      default: false
    }

  },

  data () {
    return {
      currentTab: 'insurer',
      localSite: this.rowData
    }
  }
}

</script>



// WEBPACK FOOTER //
// SiteInsurance.vue?5d20e1b2